import { useEffect, useState } from "react";
import { ShieldCheck, Trash2, Plus } from "lucide-react";
import { toast } from "sonner";
import { api, toastErr } from "@/lib/api";
import { Card, Label, inputCls, PrimaryButton } from "./ui";

export const AdminsTab = () => {
  const [admins, setAdmins] = useState([]);
  const [email, setEmail] = useState("");

  const load = () => api.get("/admin/admins").then((r) => setAdmins(r.data)).catch(toastErr);
  useEffect(() => { load(); }, []);

  const add = async () => {
    try { await api.post("/admin/admins", { email }); setEmail(""); toast.success("Admin added"); load(); }
    catch (e) { toastErr(e); }
  };
  const remove = async (a) => {
    try { await api.delete(`/admin/admins/${encodeURIComponent(a.email)}`); toast.success("Admin removed"); load(); }
    catch (e) { toastErr(e); }
  };

  return (
    <div className="max-w-2xl space-y-6">
      <Card title="Add admin">
        <Label>Google email</Label>
        <div className="flex gap-2">
          <input data-testid="admin-email-input" className={inputCls} placeholder="name@company.com" value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} />
          <PrimaryButton data-testid="admin-whitelist-add-button" onClick={add} disabled={!email.includes("@")}><Plus size={16} /> Add</PrimaryButton>
        </div>
        <p className="mt-2 text-xs text-slate-500">They sign in at /backoffice with Google using this exact email.</p>
      </Card>
      <Card title={`Admins (${admins.length})`}>
        <ul className="divide-y divide-slate-100">
          {admins.map((a) => (
            <li key={a.email} data-testid="admin-list-item" className="flex items-center gap-3 py-3">
              <ShieldCheck size={18} className={a.is_super ? "text-indigo-600" : "text-slate-400"} />
              <span className="flex-1 text-sm text-slate-900">{a.email}</span>
              {a.is_super ? <span className="text-[11px] font-semibold uppercase tracking-wider bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded-full">Super admin</span>
                : <button data-testid="admin-remove-button" onClick={() => remove(a)} className="p-2 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-lg" aria-label="Remove"><Trash2 size={16} /></button>}
            </li>
          ))}
        </ul>
      </Card>
    </div>
  );
};
